// 2026-09-26 (Eric): "Merge NJ Warehouses" printing — one ticket per order with
// the Tinton Falls items first, a dividing rule, then the Eatontown items.
// Offered only when printing from one of these two warehouses on the stores
// listed here. The two names are the Shopify location names; a store may
// suffix them (City Sports: "Tinton Falls Warehouse (City Sports)"), so the
// check is "starts with". 2026-09-27 (Eric): City Sports added.
export const NJ_WAREHOUSE_NAMES = ['Tinton Falls Warehouse', 'Eatontown Warehouse'];
export const NJ_MERGE_STORES = new Set(['soccerpost', 'b2b', 'stefans', 'u90', 'surf', 'citysports']);
export const MERGE_NJ_STORAGE_KEY = 'print_merge_nj_warehouses';

export const isNjWarehouseName = (name) => {
    const n = String(name || '').trim().toLowerCase();
    return NJ_WAREHOUSE_NAMES.some(w => n === w.toLowerCase() || n.startsWith(w.toLowerCase()));
};
export const njMergeAllowed = (storeKey) => NJ_MERGE_STORES.has(String(storeKey || 'soccerpost'));
const njRank = (name) => NJ_WAREHOUSE_NAMES.findIndex(w => String(name || '').toLowerCase().startsWith(w.toLowerCase()));

/** The NJ warehouses that hold open items on a full (GraphQL-shaped) order,
 *  Tinton Falls first. With `all` true, closed / fulfilled FOs count too
 *  (the "reprint full order" case). [{ id, name }] */
export function njWarehouseLocsOnOrder(fullOrder, { all = false } = {}) {
    const seen = new Map();
    for (const e of (fullOrder?.fulfillmentOrders?.edges || [])) {
        const fo = e?.node || {};
        const name = fo.assignedLocation?.name || '';
        if (!isNjWarehouseName(name)) continue;
        const open = fo.status === 'OPEN' || fo.status === 'IN_PROGRESS';
        const remaining = (fo.lineItems?.edges || []).reduce((s, li) => s + (Number(li?.node?.remainingQuantity) || 0), 0);
        const total = (fo.lineItems?.edges || []).reduce((s, li) => s + (Number(li?.node?.totalQuantity) || 0), 0);
        if (!(all ? total > 0 : (open && remaining > 0))) continue;
        const id = String((fo.assignedLocation?.location?.id || '').split('/').pop() || '');
        if (id && !seen.has(id)) seen.set(id, { id, name });
    }
    return [...seen.values()].sort((a, b) => njRank(a.name) - njRank(b.name));
}

export const readMergeNjPref = () => { try { return localStorage.getItem(MERGE_NJ_STORAGE_KEY) === '1'; } catch (_) { return false; } };
export const writeMergeNjPref = (on) => { try { localStorage.setItem(MERGE_NJ_STORAGE_KEY, on ? '1' : '0'); } catch (_) { /* private window */ } };
